import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = mode === "login"
        ? await login(form.email, form.password)
        : await register(form);
      toast.success(`Welcome${user.name ? ", " + user.name : ""}!`);
      nav(user.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16 bc-dusty">
      <div className="w-full max-w-md bg-[hsl(var(--ivory))] border border-border p-10">
        <div className="text-center mb-7">
          <div className="font-logo text-2xl tracking-[0.18em] text-foreground">BODYCRUSH</div>
          <p className="text-[10px] uppercase tracking-luxe text-muted-foreground mt-1">by Gujarish · Smart Intimates</p>
        </div>
        <h1 className="font-display text-3xl font-light text-center">{mode === "login" ? "Welcome back" : "Create account"}</h1>
        <p className="text-sm text-muted-foreground text-center mt-1 font-light">{mode === "login" ? "Log in to see your orders" : "Sign up to track your orders"}</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          {mode === "register" && (
            <>
              <Input label="Full Name" value={form.name} onChange={set("name")} testid="auth-name" />
              <Input label="Phone" value={form.phone} onChange={set("phone")} testid="auth-phone" />
            </>
          )}
          <Input label="Email" type="email" value={form.email} onChange={set("email")} testid="auth-email" />
          <Input label="Password" type="password" value={form.password} onChange={set("password")} testid="auth-password" />
          <button disabled={loading} className="w-full bg-foreground text-[hsl(var(--ivory))] py-4 text-xs uppercase tracking-[0.2em] hover:bg-primary transition-colors disabled:opacity-60" data-testid="auth-submit">
            {loading ? "Please wait…" : mode === "login" ? "Log In" : "Sign Up"}
          </button>
        </form>

        <p className="text-center text-sm text-muted-foreground mt-5">
          {mode === "login" ? "New here? " : "Already have an account? "}
          <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-primary font-semibold" data-testid="auth-toggle">
            {mode === "login" ? "Create account" : "Log in"}
          </button>
        </p>
        <p className="text-center text-xs text-muted-foreground mt-4">
          <Link to="/shop" className="hover:text-primary">Continue as guest →</Link>
        </p>
      </div>
    </div>
  );
}

const Input = ({ label, type = "text", value, onChange, testid }) => (
  <div>
    <label className="text-sm font-medium">{label}</label>
    <input type={type} value={value} onChange={onChange} data-testid={testid} required
      className="mt-1.5 w-full border border-input bg-[hsl(var(--ivory))] px-3 py-2.5 text-sm outline-none focus:border-primary" />
  </div>
);
